<template>
  <!-- Impact × probability matrix in the workspace's scale: counts of scenarios, or a cell to pick (US 9370) -->
  <div class="rk-mx-wrap">
    <div class="rk-mx" :style="{ gridTemplateColumns: '18px repeat(' + scale.impact.length + ', minmax(0, 1fr))' }">
      <template v-for="(probability, row) in rows">
        <span :key="'p' + row" class="rk-mx__ax" :title="$t('probability.' + levelKey(probability))">{{ scale.probability.length - row }}</span>
        <button v-for="(impact, col) in scale.impact"
                :key="row + '-' + col"
                type="button"
                class="rk-mx__c"
                :class="['is-' + band(scale, (col + 1) * (scale.probability.length - row)), { 'is-dim': !counts[impact + '|' + probability] && !isPicked(impact, probability), 'is-pick': isPicked(impact, probability) }]"
                :disabled="!pickable"
                :title="$t('impact.' + levelKey(impact)) + ' × ' + $t('probability.' + levelKey(probability))"
                @click="$emit('pick', { impact: impact, probability: probability })">{{ counts[impact + '|' + probability] || '' }}</button>
      </template>
      <span></span>
      <span v-for="(impact, col) in scale.impact" :key="'i' + col" class="rk-mx__ax" :title="$t('impact.' + levelKey(impact))">{{ col + 1 }}</span>
    </div>
    <div class="rk-mx__axes"><span>{{ $t('risk_tab.impact') }} →</span><span>↑ {{ $t('risk_tab.probability') }}</span></div>
  </div>
</template>

<script>
  import {band, levelKey} from '@/components/risk/riskScale.js';

  export default {
    name: 'RiskMatrix',
    props: {
      scale: { type: Object, required: true },
      // { 'impact|probability': number of scenarios }
      counts: { type: Object, default: () => ({}) },
      picked: { type: Object, default: null },
      pickable: { type: Boolean, default: false }
    },
    computed: {
      // Highest probability on top
      rows() {
        return this.scale.probability.slice().reverse();
      }
    },
    methods: {
      band: band,
      levelKey: levelKey,
      isPicked(impact, probability) {
        return !!this.picked && this.picked.impact === impact && this.picked.probability === probability;
      }
    }
  }
</script>
